const DEVELOPMENT_URL = `http://192.168.1.28:2810/v1`;
const STAGING_URL = `https://aums.api.ansoftt.com:1028/v1`;
const PRODUCTION_URL = `https://aums.api.ansoftt.com:2810/v1`;

export const BASE_URL = STAGING_URL;
